<template>
  <!-- NOTE (TEMPLATE) to show the proposal page -->

  <div>
    <!-- loading component -->
    <Loading />
    <Elite role="manager" />
  </div>
</template>

<script>
const Elite = () => import("../../components/Elite");

export default {
  components: {
    Elite // NOTE (COMPONENT) component of proposal
  },
  data() {
    return {};
  },

  methods: {}
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
